import React , { useState }from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import {MenuOutlined,GlobalOutlined} from '@ant-design/icons';
import {Menu, Dropdown} from 'antd';
import './Header.css';
import logo1 from '../assets/images/logo1.png';

const switchSite = [
  {
    key: '1',
    label: (
      <Link to="https://neohotech.com.cn">中国站</Link>
    ),
  },
  {
    key: '2',
    label: (
      <Link to="https://neohotech.com">International</Link>
    ),
  }
];



  const itemsForMobile = [
    {
      key: '1',
      label: (
        <Link to="/">Home</Link>
      ),
    },
    {
      key: '2',
      label: (
        <Link to="/brand">Brand Story</Link>
      ),
    },
    {
      key: '3',
      label: (
        <Link to="/joinus">Join us</Link>
      ),
    },
  ];

  function MobileHeader() {
    const [current, setCurrent] = useState('mail');
    const onClick = (e) => {
      console.log('click ', e);
      setCurrent(e.key);
    };
  
    return (
      <header className="header">
        <p className='header-title'>NEOHOTECH</p>
        <Dropdown
          className="menu-icon"
          overlay={<Menu items={itemsForMobile} onClick={onClick} />}
          placement="bottomRight"
        >
          <MenuOutlined />
        </Dropdown>
        <Dropdown
                className="switchSite-icon"
                overlay={<Menu items={switchSite} onClick={onClick} />}
                placement="bottomRight"
              >
                <GlobalOutlined />
              </Dropdown>
      </header>
    );
  }


  function DesktopHeader () {
    const [current, setCurrent] = useState('mail');
    const onClick = (e) => {
      console.log('click ', e);
      setCurrent(e.key);
    };
    return (
      <header className="header">
        <img src={logo1} alt="company logo" className="logo" />
        <nav className="navigation">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/Brand">Brand</Link></li>
            <li><Link to="/Joinus">Join us</Link></li>
            <li>
              <Dropdown
                className="switchSite-icon"
                overlay={<Menu items={switchSite} onClick={onClick} />}
                placement="bottomRight"
              >
                <GlobalOutlined />
              </Dropdown>
            </li>
          </ul>
        </nav>
      </header>
    );
  }

function Header() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    return (
      <div className="">
        {isMobile ? <MobileHeader /> : <DesktopHeader />}
      </div>
    );
  };

  export default Header;
